export default function createHistory(wrapper, history) {
	var listen = history.listen.bind(history);
	var listeners = [];
	listen(function (location, action) {
		var _location = wrapper._location;

		var prevLocation = {
			pathname: _location._pathname,
			search: _location._search,
			hash: _location._hash,
			query: _location.query
		};
		_location._pathname = location.pathname;
		_location._search = location.search;
		_location._hash = location.hash;
		var _iteratorNormalCompletion = true;
		var _didIteratorError = false;
		var _iteratorError = undefined;

		try {
			for (var _iterator = listeners[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
				var listener = _step.value;

				listener(_location, prevLocation, action);
			}
		} catch (err) {
			_didIteratorError = true;
			_iteratorError = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion && _iterator.return) {
					_iterator.return();
				}
			} finally {
				if (_didIteratorError) {
					throw _iteratorError;
				}
			}
		}
	});
	history.listen = function listen(listener) {
		listeners.push(listener);
		return function removeListener() {
			var index = listeners.indexOf(listener);

			/* istanbul ignore else */
			if (index >= 0) {
				listeners.splice(index, 1);
			}
		};
	};
	return history;
}